import React, { useRef } from 'react';
import styles from "./AnimatedButton2.module.css";
import Loader from '../Loader/Loader';

// Inverted-color sibling of AnimatedButton — same API surface, white body
// with purple text + stroke instead of solid purple body. Use this when
// the surrounding container is already brand-purple (e.g. the
// post-purchase Thank You InfoBox) and the regular variant would visually
// disappear into the background.
//
// Shape mirrors the original via an inline SVG with the same path as
// public/svg/svg-theme2.svg (slightly bowed pill) — keeps the brand
// silhouette consistent across both variants.

const VARIANTS = {
  default: {
    fill: "#ffffff",
    color: "#6524EB",
  },
  green: {
    fill: "#00C524",   // brand green
    color: "#ffffff",
  },
  purple: {
    fill: "#6524EB",
    color: "#ffffff",
  },
  red: {
    fill: "#DA1B14",
    color: "#ffffff",
  },
};

const AnimatedButton2 = ({
  isLoading,
  size,
  label = 'Save',
  position = {},
  positionType = "fixed",
  bottom = {},
  width,
  onClick = () => { },
  disabled = false,
  variant = "default",
}) => {
  const svgRef = useRef(null);
  const textRef = useRef(null);
  const theme = VARIANTS[variant] ?? VARIANTS.default;
  const handleZoomAnimation = () => {
    const svg = svgRef.current;
    const text = textRef.current;
    if (!svg || !text) return;
    [svg, text].forEach((el) => {
      el.classList.remove(styles.zoomAnimate);
      void el.offsetWidth; // force reflow so the animation re-triggers
      el.classList.add(styles.zoomAnimate);
    });
  };

  return (
    <div
      className={styles.btnFix}
      style={{
        position: positionType,
        width,
        ...position,
        bottom: bottom ? bottom : '10px',
      }}
    >
      <div
        className={styles.btnTheme}
        onMouseEnter={handleZoomAnimation}
        onTouchStart={handleZoomAnimation}
        onClick={disabled ? null : onClick}
        style={{
          pointerEvents: isLoading || disabled ? 'none' : 'auto',
          opacity: isLoading || disabled ? 0.6 : 1,
          cursor: isLoading || disabled ? 'not-allowed' : 'pointer',
        }}
      >
        {/* Inline SVG with same path as svg-theme2.svg (357x57 bowed pill).
            White fill + purple stroke so it stands out on purple bg. */}
        <svg
          ref={svgRef}
          className={styles.btnShape}
          viewBox="0 0 357 57"
          preserveAspectRatio="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M0 15.8809C0 8.25752 6.07777 2.03752 13.6999 1.89818C45.1625 1.32299 124.097 -0.0107212 179.02 6.50351e-05C233.456 0.0107557 311.9 1.33021 343.255 1.89985C350.878 2.03834 356.961 8.25885 356.961 15.8831V40.1954C356.961 47.8196 350.878 54.0401 343.255 54.1786C311.9 54.7483 233.456 56.0678 179.02 56.0785C124.097 56.0893 45.1625 54.7555 13.6998 54.1803C6.07776 54.041 0 47.8209 0 40.1976V15.8809Z"
            fill={theme.fill}
          />
        </svg>
        {/* <p style={{ fontSize: size ? size : null }} ref={textRef}>
          {isLoading ? <Loader size={17} /> : label}
        </p> */}
        <p
          style={{
            fontSize: size ? size : null,
            color: theme.color,   // text color bhi variant ke hisaab se
          }}
          ref={textRef}
        >
          {isLoading ? <Loader size={17} /> : label}
        </p>
      </div>
    </div>
  );
};

export default AnimatedButton2;
